import MiddlePanel from 'Components/MiddlePanel/MiddlePanel'
import Panel from 'Components/Panel/Panel'
import { ptBR } from 'date-fns/locale'
import ReactDatePicker from 'react-datepicker'
import { useState } from 'react'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios'
import './NewMonthPanel.css'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp'

const NewMonthPanel = ({
    showNewMonthPanel,
    onUpdateShowNewMonthPanel,
    onUpdatePanelCostSpreadsheet,
    onUpdateLoadingItemsMonth
}) => {
    const [dtStart, setDtStart] = useState(null);
    const [dtFinish, setDtFinish] = useState(null);
    const [loadedScreen, setLoadedScreen] = useState(true);

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    };

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        paddingLeft: '30px'
    }

    function onUpdateDtStart(date) {
        setDtStart(date)
        setDtFinish(new Date(date.getFullYear(), 11, date.getDate()))
    }

    function cancelFunction() {
        onUpdateShowNewMonthPanel(false);
        resetVariables();
    }

    function resetVariables() {
        setDtStart(null);
        setDtFinish(null);
    }

    async function postFunction() {
        try {
            setLoadedScreen(false)
            onUpdateLoadingItemsMonth(true)
            const response = await ExecuteAxios.api('post', `/cost-day/between-selected-months/`, {
                dtStart: dtStart,
                dtFinish: dtFinish
            });
            if (response) {
                resetVariables()
                onUpdateShowNewMonthPanel(false)
                onUpdatePanelCostSpreadsheet(true)
            }
            return response
        } catch (error) {
            console.log(error)
        } finally {
            setLoadedScreen(true)
            onUpdateLoadingItemsMonth(false)
        }
    }

    return (
        <MiddlePanel isVisible={showNewMonthPanel}>
            <Panel style={{
                width: '400px',
                height: '145px',
                padding: '5px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5;',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <Panel titlePage={'Gerar orçamento'}
                    style={panelListStyle}
                    canViewCRUD={true}
                    postFunction={postFunction}
                    cancelFunction={cancelFunction}
                    enableNewRecord={true}
                    canNewRecord={true}
                    enableDelete={true}
                    canDelete={true}
                    recordsSelected={[]}
                    inserting={true}>
                    <Panel style={styleButtonsMonth}>
                        <LoadingIndicator loaded={loadedScreen}>
                            <div id='attribute-control' style={{ flexDirection: 'center', width: '100%' }}>
                                <span className='span-role-control'>Mês inicial</span>
                                <ReactDataPickerComp
                                    selected={dtStart}
                                    onChange={(date) => { onUpdateDtStart(date) }}
                                    showMonthYearPicker={true}
                                    className='spreadsheet-new-month-date-picker cursor-pointer'
                                    dateFormat={'MM/yyyy'}
                                    setter={onUpdateDtStart}
                                />
                            </div>
                            <div id='attribute-control' style={{ flexDirection: 'center', width: '100%' }}>
                                <span className='span-role-control'>Mês final</span>
                                <ReactDataPickerComp
                                    selected={dtFinish}
                                    onChange={(date) => { setDtFinish(date) }}
                                    showMonthYearPicker={true}
                                    className='spreadsheet-new-month-date-picker cursor-pointer'
                                    dateFormat={'MM/yyyy'}
                                    setter={setDtFinish}
                                />
                            </div>
                        </LoadingIndicator>
                    </Panel>
                </Panel>
            </Panel>
        </MiddlePanel >
    );
}

export default NewMonthPanel;
